/* eslint-disable no-undef */
import PlayerEvent from '../../../core/events/player.event';
import * as AdEvent from '../../../core/events/ad.events';
import { logDebugging, logError } from '../../../log/logger';

export default class IMAPlayerListeners {
  constructor(idComponent, playerView, cid) {
    this.idComponent = idComponent;
    this.isActivateListeners = false;
    this.isFirstStart = false;
    this.IMAPlayerEvent = new PlayerEvent('onIMAPlayerEvent');
    this.intervalTime = 0;
    this.duration = 0;
    this.errorSent = false;
    this.allCompleteSent = false;
    this.completeSent = false;
    this.playerView = playerView;
    this.cid = cid;
  }

  createHandlersAdsLoader(adsLoader) {
    adsLoader.addEventListener(
      google.ima.AdErrorEvent.Type.AD_ERROR,
      (adsEvent) => {
        const adData = adsEvent.getError();
        if (adData.data && !this.allCompleteSent && !this.completeSent) {
          logDebugging(`[IMAPlayerListeners] AD_ERROR  cid${this.cid}`);
          logError(adData.data);
          this.errorSent = true;
        }
        this.dispatchEvent([AdEvent.AdError, 0, 0, adData.data]);
      },
      false,
    );
  }

  dispatchCurrentTime(remainingTime) {
    this.currentTime = this.duration - remainingTime;
    this.currentTime = this.currentTime < 0 ? 0 : this.currentTime;
    this.dispatchEvent([AdEvent.AdRemainingTimeChange, this.currentTime, this.duration]);
  }

  createHandlersAdsManager(adsManager) {
    this.adsManager = adsManager;

    adsManager.addEventListener(
      google.ima.AdErrorEvent.Type.AD_ERROR,
      (adsEvent) => {
        const adError = adsEvent.getError();
        if (adError.data) {
          logDebugging(`[IMAPlayerListeners] AD_ERROR  cid${this.cid}`);
          logDebugging(adError.data);
          this.errorSent = true;
        }
        this.dispatchEvent([AdEvent.AdError, 0, 0, adError.data]);
      },
      false,
    );

    adsManager.addEventListener(google.ima.AdEvent.Type.LOADED, () => {
      // logDebugging(`[IMAPlayerListeners] LOADED cid${this.cid}`);
      // this.dispatchEvent([PlayerEventNames.LOADEDDATA, this.currentTime, this.duration]);
    });

    adsManager.addEventListener(google.ima.AdEvent.Type.STARTED, (adsEvent) => {
      // logDebugging(`[IMAPlayerListeners] STARTED cid${this.cid}`);
      this.playerView.showAdContainer();
      this.allCompleteSent = false;
      this.duration = adsEvent.getAd().getDuration();

      this.intervalTime = setInterval(() => {
        this.dispatchCurrentTime(adsManager.getRemainingTime());
      }, 1000);
      this.dispatchEvent([AdEvent.AdLoaded, this.currentTime, this.duration]);
      setTimeout(
        () => this.dispatchEvent([AdEvent.AdStarted, this.currentTime, this.duration]),
        100,
      );
    });

    adsManager.addEventListener(google.ima.AdEvent.Type.COMPLETE, () => {
      logDebugging(`[IMAPlayerListeners] COMPLETE cid ${this.cid}`);
      clearInterval(this.intervalTime);
      this.completeSent = true;
      this.dispatchEvent([AdEvent.AdVideoComplete, this.currentTime, this.duration]);
      setTimeout(() => {
        // para permitir que se terminen de enviar los eventos complete, que en ciertas campañas se quedan en estado pending
        if (!this.allCompleteSent) {
          this.dispatchEvent([AdEvent.AdStopped, this.currentTime, this.duration]);
        }
      }, 1000);
    });

    adsManager.addEventListener(google.ima.AdEvent.Type.ALL_ADS_COMPLETED, () => {
      // console.timeEnd('time_cid_'+ this.cid + 'from_start_to_complete')
      logDebugging(`[IMAPlayerListeners] ALL_ADS_COMPLETED cid ${this.cid}`);
      this.allCompleteSent = true;
      this.playerView.remove();
      clearInterval(this.intervalTime);
      setTimeout(() => {
        // para permitir que se terminen de enviar los eventos complete, que en ciertas campañas se quedan en estado pending
        if (!this.errorSent) {
          this.dispatchEvent([AdEvent.AdStopped, this.currentTime, this.duration]);
        }
      }, 15);
    });

    adsManager.addEventListener(google.ima.AdEvent.Type.PAUSED, () => {
      logDebugging(`[IMAPlayerListeners] PAUSED cid ${this.cid}`);
      clearInterval(this.intervalTime);
      this.dispatchEvent([AdEvent.AdPaused, this.currentTime, this.duration]);
    });

    adsManager.addEventListener(google.ima.AdEvent.Type.RESUMED, () => {
      logDebugging(`[IMAPlayerListeners] RESUMED cid ${this.cid}`);
      clearInterval(this.intervalTime);
      this.intervalTime = setInterval(() => {
        this.dispatchCurrentTime(adsManager.getRemainingTime());
      }, 1000);
      this.dispatchEvent([AdEvent.AdPlaying, this.currentTime, this.duration]);
    });

    adsManager.addEventListener(google.ima.AdEvent.Type.FIRST_QUARTILE, () => {
      logDebugging('[IMAPlayerListeners] FIRST_QUARTILE ');
      this.dispatchEvent([AdEvent.AdVideoFirstQuartile, this.currentTime, this.duration]);
    });
    adsManager.addEventListener(google.ima.AdEvent.Type.MIDPOINT, () => {
      logDebugging('[IMAPlayerListeners] MIDPOINT ');
      this.dispatchEvent([AdEvent.AdVideoMidpoint, this.currentTime, this.duration]);
    });
    adsManager.addEventListener(google.ima.AdEvent.Type.THIRD_QUARTILE, () => {
      logDebugging('[IMAPlayerListeners] THIRD_QUARTILE ');
      this.dispatchEvent([AdEvent.AdVideoThirdQuartile, this.currentTime, this.duration]);
    });

    adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPABLE_STATE_CHANGED, () => {
      logDebugging('[IMAPlayerListeners] SKIPPABLE_STATE_CHANGED ');
      this.dispatchEvent([AdEvent.AdShowSkip, this.currentTime, this.duration]);
    });

    adsManager.addEventListener(google.ima.AdEvent.Type.SKIPPED, () => {
      logDebugging('[IMAPlayerListeners] SKIPPED ');
      clearInterval(this.intervalTime);

      // this.dispatchEvent([AdEvent.AdStopped, this.duration, skipped]);
    });

    /*
     */
    adsManager.addEventListener(google.ima.AdEvent.Type.CLICK, () => {
      logDebugging('[IMAPlayerListeners] CLICK ');
      this.dispatchEvent([AdEvent.AdClickThru, this.currentTime, this.duration]);
    });

    adsManager.addEventListener(google.ima.AdEvent.Type.LOG, (event) => {
      const adData = event.getAdData();
      if (adData.error && !this.allCompleteSent && !this.completeSent) {
        logDebugging(`[IMAPlayerListeners] LOG  cid ${this.cid}`);
        logDebugging(adData.adError);
        this.errorSent = true;
        this.dispatchEvent([AdEvent.AdError, 0, 0, adData]);
      }
    });
  }

  remove() {
    // this.handlers.forEach(Handler.removeListener);
    clearInterval(this.intervalTime);
    this.isActivateListeners = false;
  }

  sendError(message) {
    logDebugging(`[IMAPlayerListeners] sendError  cid${this.cid} error ${message}`);
    this.errorSent = true;
    this.dispatchEvent([AdEvent.AdError, 0, 0, message]);
  }

  dispatchEvent(arg) {
    this.IMAPlayerEvent.fire(this, { message: arg });
  }
}
